module.exports = __webpack_public_path__ + "static/media/fox.a13c8084.png";